module.exports = __webpack_public_path__ + "static/img/dengl_live_bg.6565fd68.png";